import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSampleViewHeader from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-view-header/grossing-touch-sample-view-header.vue'
import EmbeddedVoiceRecorder from '@/components/attachments/EmbeddedVoiceRecorder.vue'
import GrossingTouchVoiceRecorderCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-voice-recorder-card/grossing-touch-voice-recorder-card.vue'
import GrossingTouchTextTemplatesSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-text-templates-sidepanel/grossing-touch-text-templates-sidepanel.vue'
import GrossingTouchSynopticTemplatesSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-synoptic-templates-sidepanel/grossing-touch-synoptic-templates-sidepanel.vue'

@Component({
    components: {
        GrossingTouchSampleViewHeader,
        EmbeddedVoiceRecorder,
        GrossingTouchVoiceRecorderCard,
        GrossingTouchTextTemplatesSidepanel,
        GrossingTouchSynopticTemplatesSidepanel
    }
})

export default class GrossingTouchSampleTabMacroscopy extends Vue {
}
